<template>
  <SimpleNoteDetailTabDetail
    v-if="activeTab === 'detail'"
    :note="note"
    :operation="operation"
    :concepts="concepts"
    :comments="comments"
    :currency="currency"
    :subtotal="subtotal"
    :total="total"
    @pay-note="$emit('pay-note')"
  />

  <SimpleNoteDetailTabShipping
    v-else-if="activeTab === 'shipping'"
    :note="note"
    :refresh-tick="shippingRefreshTick"
  />
  <SimpleNoteDetailTabDocuments v-else-if="activeTab === 'documents'" :note="note" />
  <SimpleNoteDetailTabHistory v-else-if="activeTab === 'history'" :note="note" />

  <SimpleNoteDetailTabDetail
    v-else
    :note="note"
    :operation="operation"
    :concepts="concepts"
    :comments="comments"
    :currency="currency"
    :subtotal="subtotal"
    :total="total"
    @pay-note="$emit('pay-note')"
  />
</template>

<script>
import SimpleNoteDetailTabDetail from '@/components/simple-notes/detail/tabs/SimpleNoteDetailTabDetail.vue';
import SimpleNoteDetailTabShipping from '@/components/simple-notes/detail/tabs/SimpleNoteDetailTabShipping.vue';
import SimpleNoteDetailTabDocuments from '@/components/simple-notes/detail/tabs/SimpleNoteDetailTabDocuments.vue';
import SimpleNoteDetailTabHistory from '@/components/simple-notes/detail/tabs/SimpleNoteDetailTabHistory.vue';

export default {
  name: 'SimpleNoteDetailTabsPanel',
  components: {
    SimpleNoteDetailTabDetail,
    SimpleNoteDetailTabShipping,
    SimpleNoteDetailTabDocuments,
    SimpleNoteDetailTabHistory,
  },
  props: {
    activeTab: {
      type: String,
      required: true,
    },
    note: {
      type: Object,
      default: null,
    },
    operation: {
      type: Object,
      default: () => ({}),
    },
    concepts: {
      type: Array,
      default: () => [],
    },
    comments: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    subtotal: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    shippingRefreshTick: {
      type: Number,
      default: 0,
    },
  },
  emits: ['pay-note'],
};
</script>
